import { createLiveQueryPatchGenerator, } from "./createLiveQueryPatchGenerator.js";
const isAsyncIterable = (value) => {
    return (typeof value === "object" && value !== null && Symbol.asyncIterator in value);
};
/**
 *  after-ware for wrapping execute in order to generate live query patches.
 */
export const createApplyLiveQueryPatchGenerator = (generatePatch) => {
    return (executionResult) => {
        const makePatch = createLiveQueryPatchGenerator(generatePatch);
        const handler = (result) => {
            if (isAsyncIterable(result)) {
                return makePatch(result);
            }
            return result;
        };
        if (executionResult instanceof Promise) {
            return executionResult.then(handler);
        }
        return handler(executionResult);
    };
};
